export const styles = {
  errorContainer: 'tw-bg-white tw-rounded-md tw-border tw-border-neutral-200 tw-overflow-hidden',
  error: 'tw-p-4 tw-text-danger-500 tw-text-center',
  nameContainer: 'tw-flex tw-items-center tw-gap-3',
  avatar: 'tw-w-9 tw-h-9 tw-rounded-full tw-bg-primary-600 tw-flex tw-items-center tw-justify-center tw-text-white tw-font-medium tw-text-sm',
  name: 'tw-font-medium tw-text-neutral-900',
  email: 'tw-text-neutral-600',
};
